export default __webpack_public_path__ + "8e53c0469b15759375628feabdab3b5d.jpg";